import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, IconButton, Toolbar, Typography } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import FormularioApp from "app/Core/Components/Formulario/FormularioApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import XAPPButton from "../../Core/Components/Button/XAPPButton";
import LogRegistro from "../../Core/Components/LogRegistro/LogRegistroApp";
import * as Actions from "./Store/Actions/EmpresaContaActions";

const md = new MobileDetect(window.navigator.userAgent);

const newContaState = {
    tabValue: 0,
    idpessoaformulario: null,
    idpessoa: null,
    tipo: 123,
    formulario: {},
    requeridos: null,
};

class EmpresaContaDialog extends XAPPComponent {

    state = { ...newContaState };

    componentDidMount() {
        if (_.isUndefined(this.props.template) || _.isNull(this.props.template)) {
            this.props.getTemplate();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { xappRouteParams } = this.props;

        if (this.props.formDialog.props.error) {
            this.props.showMessage({
                message: this.props.formDialog.props.error,
                variant: "error"
            });
            this.props.formDialog.props.error = null;
        }
        if (this.props.formDialog.props.warning) {
            this.props.showMessage({
                message: this.props.formDialog.props.warning,
                variant: "warning"
            });
            this.props.formDialog.props.warning = null;
        }
        if (this.props.formDialog.props.info) {
            this.props.showMessage({
                message: this.props.formDialog.props.info,
                variant: "success"
            });
            this.props.formDialog.props.info = null;
            if (!this.state.idpessoaformulario || this.state.idpessoaformulario === null) {
                this.setState({ idpessoaformulario: this.props.formDialog.props.id });
            }
        }

        if (!prevProps.formDialog.props.open && this.props.formDialog.props.open) {
            var obj = { ...newContaState };
            obj.idpessoa = xappRouteParams.empresa;

            if (this.props.formDialog.type === "edit" &&
                this.props.formDialog.data &&
                !_.isEqual(this.props.formDialog.data, prevState)) {
                obj.idpessoaformulario = this.props.formDialog.data.idpessoaformulario;
                obj.idpessoa = this.props.formDialog.data.formulario.idpessoa;
                obj.statusregistro = this.props.formDialog.data.statusregistro;
                obj.formulario = { ...this.props.formDialog.data.formulario };
            }
            this.setState(obj);
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value));
    };

    closeComposeDialog = () => {
        this.props.formDialog.type === "edit" ? this.props.closeEditDialog() : this.props.closeNewDialog();
    };


    excluir = () => {
        this.props.remove(this.state, this.props.xappRouteParams);
        this.closeComposeDialog();
    };

    handleChangeFormulario = (_AForm) => {
        this.setState({ "formulario": _AForm });
    };

    setRequeridos = (_ARequeridos) => {
        this.setState(_.set({ ...this.state }, "requeridos", _ARequeridos));
    };

    canBeSubmitted = () => {
        const { requeridos, formulario } = this.state;
        if ((Object.keys(formulario).length < 1) || (requeridos === null)) {
            return false;
        }
        var AResponse = true;
        Object.keys(requeridos).forEach(key => {
            if (AResponse && requeridos[key] &&
                (_.isUndefined(formulario[key]) || _.isNull(formulario[key]) || formulario[key].length < 1)) {
                AResponse = false;
            }
        });

        return AResponse;
    };

    handleChangeTab = (event, tabValue) => {
        this.setState({ tabValue });
    };

    render() {
        const { formDialog, save, xappRouteParams, template, acaoRegistro, callback } = this.props;
        const form = this.state;
        return (
            <XAPPDialog
                {...formDialog.props}
                id="EmpresaConta"
                onClose={this.closeComposeDialog}
                fullWidth
                fullScreen={md.mobile() !== null}
                maxWidth={md.mobile() === null && md.tablet() === null && "lg"}
            >

                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {formDialog.type === "new" ? "Novo registro" : "Editar registro"}
                        </Typography>
                        {formDialog.data && (
                            <LogRegistro
                                primaryKey={"idpessoaformulario"}
                                Log={formDialog.data}
                            />
                        )}
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={this.closeComposeDialog}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <DialogContent className="p-0">
                    {form.tabValue === 0 &&
                        <div className="p-24">
                            {template !== undefined && template !== null &&
                                <FormularioApp
                                    Formulario={template}
                                    onChange={this.handleChangeFormulario}
                                    customProps={[]}
                                    setRequeridos={this.setRequeridos}
                                    data={this.state.formulario}
                                    xappRouteParams={xappRouteParams}
                                />
                            }
                        </div>
                    }
                </DialogContent>
                {form.tabValue === 0 &&
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            <DialogActions>
                                {this.state.idpessoaformulario !== null &&
                                    <XAPPButton
                                        type="Button"
                                        className="bg-grey-darker hover:bg-grey-darker text-white mr-8"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            acaoRegistro(this.state, this.props.xappRouteParams, this.state.statusregistro === 0 ? "ATIVAR" : "INATIVAR", callback);
                                            this.closeComposeDialog();
                                        }}
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        icon={"block"}
                                        label={md.mobile() === null && md.tablet() === null ? (this.state.statusregistro === 0 ? "Ativar" : "Inativar") : ""}
                                    />
                                }
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white mr-8"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        save(this.state, this.props.xappRouteParams, callback);
                                    }}
                                    disabled={!this.canBeSubmitted()}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"save"}
                                    label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                                />
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                }
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeEditDialog: Actions.closeEditDialog,
        closeNewDialog: Actions.closeNewDialog,
        save: Actions.save,
        acaoRegistro: Actions.acaoRegistro,
        getTemplate: Actions.getTemplate,
        showMessage: AppActions.showMessage,
        hideMessage: AppActions.hideMessage,
    }, dispatch);
}

function mapStateToProps({ EmpresaConta }) {
    return {
        formDialog: EmpresaConta.formDialog,
        template: EmpresaConta.template
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpresaContaDialog);
